import { TextField, Typography, Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import DesignationSelect from "../../utils/designationSelect";

// Converts dd-MM-yyyy (stored) → yyyy-MM-dd (for HTML date input display)
const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("-");
    return `${year}-${month}-${day}`;
};

// Converts yyyy-MM-dd (from HTML date input) → dd-MM-yyyy (for storage / backend)
const formatDateForStorage = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
};


const RelievingLetterForm = ({ data, setData }) => {

    const handleChange = (key, value) => {
        if (key === "relieving_letter_date" || key === "resignation_date" ||
            key === "joining_date" || key === "last_working_date") {
            value = formatDateForStorage(value);
        }

        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Box sx={{ mt: 1 }}>


            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 2
                }}
            >
                <Box>
                    <TextField
                        type="date"
                        label="Relieving Letter Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.relieving_letter_date ? formatDateForInput(data.relieving_letter_date) : ""}
                        onChange={(e) => handleChange("relieving_letter_date", e.target.value)}
                    />
                </Box>

                {/* <Box>
                    <TextField
                        label="Employee Address"
                        fullWidth
                        value={data.employee_address || ""}
                        onChange={(e) => handleChange("employee_address", e.target.value)}
                    />
                </Box> */}

                <Box>
                    <TextField
                        type="date"
                        label="Resignation Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.resignation_date ? formatDateForInput(data.resignation_date) : ""}
                        onChange={(e) => handleChange("resignation_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Joining Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.joining_date ? formatDateForInput(data.joining_date) : ""}
                        onChange={(e) => handleChange("joining_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <TextField
                        type="date"
                        label="Last Working Date"
                        fullWidth
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                        value={data.last_working_date ? formatDateForInput(data.last_working_date) : ""}
                        onChange={(e) => handleChange("last_working_date", e.target.value)}
                    />
                </Box>

                <Box>
                    <DesignationSelect
                        value={data.designation || ""}
                        onChange={(e) => handleChange("designation", e.target.value)}
                    />
                </Box>

                <Box>
                    <FormControl fullWidth>
                        <InputLabel id="department-label">Department</InputLabel>
                        <Select
                            labelId="department-label"
                            label="Department"
                            value={data.department_name || ""}
                            onChange={(e) => handleChange("department_name", e.target.value)}
                        >
                            <MenuItem value="Admin">Admin</MenuItem>
                            <MenuItem value="Accounting">Accounting</MenuItem>
                            <MenuItem value="Bookkeeping">Bookkeeping</MenuItem>
                            <MenuItem value="Payroll">Payroll</MenuItem>
                            <MenuItem value="Audit">Audit</MenuItem>
                            <MenuItem value="Marketing">Marketing</MenuItem>
                            <MenuItem value="IT">IT</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>
        </Box>
    );
};

export default RelievingLetterForm;
